import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProjectSelector from "../components/ProjectSelector";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import BandeauAidants from "../components/BandeauAidants";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { faqJsonLd, serviceJsonLd } from "../utils/donneesStructurees";
import { faqMaPrimeAdapt } from "../utils/faqMaPrimeAdapt";

const Homepage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        titre="MaPrimeAdapt' Île-de-France | AMO agréé ANAH"
        description="AMO agréé ANAH en Île-de-France : nous montons votre dossier MaPrimeAdapt' de A à Z. Jusqu'à 70 % de vos travaux financés, accompagnement gratuit."
        chemin="/"
        donnees={[
          serviceJsonLd({
            nom: "Accompagnement AMO MaPrimeAdapt'",
            description:
              "Montage complet du dossier MaPrimeAdapt' : visite d'évaluation, devis, dépôt auprès de l'ANAH et suivi jusqu'au versement des aides.",
            url: "/",
          }),
          // Seules les questions réellement affichées ici sont déclarées.
          faqJsonLd(faqMaPrimeAdapt.slice(0, 10)),
        ]}
      />
      <Header />

      <main id="contenu">
      <Hero />
      <ProjectSelector />
      <Services />
      <Testimonials />
      <BandeauAidants />
      <FAQ />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;